var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHorde(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "horde"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b30000",
    d: "M31.918 12.877c13.893 3.155 12.677 15.606 8.909 20.167-3.77 4.559-5.351 10.961-5.351 10.961-1.666 10.96.262 19.555.262 19.555 2.631-3.77 7.279-13.853 7.279-13.853-2.891 1.053-4.293 0-4.471-2.722-.176-2.718 1.58-7.451 4.471-9.646 2.892-2.191 6.666 1.318 6.666 1.318 2.455-2.37 8.156-12.629 8.156-12.629s.64-.263-3.511 2.718c-4.144 2.984-6.134 1.93-6.134 1.93-1.142-4.998 6.134-9.821 6.134-9.821-.086-.877-6.4-8.068-6.4-8.068s-1.049-6.4-1.756-6.926c-.698-.528-4.995 1.927-4.995 1.927L31.917.334l-9.152 7.454s-4.296-2.455-4.994-1.927c-.704.526-1.759 6.926-1.759 6.926s-6.311 7.19-6.399 8.068c0 0 7.278 4.823 6.135 9.821 0 0-1.99 1.054-6.135-1.93-4.149-2.982-3.51-2.718-3.51-2.718s5.703 10.259 8.155 12.629c0 0 3.775-3.508 6.667-1.318 2.892 2.195 4.647 6.929 4.473 9.646-.179 2.722-1.581 3.774-4.473 2.722 0 0 4.647 10.083 7.28 13.853 0 0 1.927-8.595.263-19.555 0 0-1.582-6.401-5.353-10.961-3.77-4.562-5.249-17.012 8.645-20.167h.158z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b30000",
    d: "M31.926 30.281c.223-.043.564-.306.564-.306l5.352-6.71s-3.287-4.517-4.475-5.962c-1.182-1.447-1.441-1.183-1.441-1.183h.044s-.256-.264-1.438 1.183c-1.186 1.445-4.476 5.962-4.476 5.962l5.351 6.71s.339.263.562.306"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorde);
export default __webpack_public_path__ + "static/media/horde.e115baa2719c168bdf94fe5fef3565de.svg";
export { ForwardRef as ReactComponent };